module.exports = __webpack_public_path__ + "resources/img/img_dvision7.6300fa68c9925d43345dfbc1f76c3aed.png";